
import Custom from './custom'

export default {
    loading:true,
    stateReload:false,
    language: 'en',
    authUser: {},
    menus: [],
    userStatusList: [],
    list: [],
    pendingMerchantList: [],
    pickupRequestList: [],
    paymentRequestList: [],
    issueRequestList: [],
    complainRequestList: [],
    banks: [],
    hubs: [],
    zones: [],
    weightCharges: [],
    stores: [],
    reasons: [],
    merchants: [],
    riders: [],
    logisticPartners: [],
    summary: false,
    headStatusList: Custom.headStatusList,
    statusList: Custom.statusList,
    typeList: Custom.typeList,
    dateParameterList: Custom.dateParameterList,
    dateTypeList: Custom.dateTypeList,
    paymentByList: Custom.paymentByList,
    categoryList: Custom.categoryList,
    merchantAccountList: Custom.merchantAccountList,
    riderCategoryList: Custom.riderCategoryList,
    monthList: Custom.monthList,
    weightList: Custom.weightList,
    lotStatusList: Custom.lotStatusList,
    commonObj: {
        hasDropdownLoaded: false,
        perPage: 10,
        divisionList: [],
        districtList: [],
        thanaList: [],
        merchantList: [],
        areaList: [],
        zoneList: [],
        zoneAreaList: [],
        bankList: [],
        hubList: [],
        logisticPartnerList: [],
        riderList: [],
        reasonList: [],
        weightChargeList: [],
        issueList: [],
        roleList: []
    }
}